import React from 'react'
import { SelectArrayInput } from 'react-admin'
import { SelectArrayInputProps } from 'types/common'

const KSelectArrayInput: React.FC<SelectArrayInputProps> = ({
  defaultValue = [],
  ...rest
}) => <SelectArrayInput defaultValue={defaultValue} {...rest} />
export default KSelectArrayInput
